import { useState } from 'react'
import { useLatestVersionInfo, VersionInfo } from '~/queries/appVersionQueries'
import { appVersion } from '~/utils/common'

// Only check for updates in production every 5 minutes.
const refetchInterval = 5 * 60 * 1000
export const useClientUpdateAvailableCheck = () => {
  const [lastChecked, setLastChecked] = useState<Date>(new Date())
  const [latestVersionInfo, setLatestVersionInfo] = useState<VersionInfo>()

  const onQuerySuccess = (data: VersionInfo) => {
    setLatestVersionInfo(data)
    setLastChecked(new Date())
  }

  useLatestVersionInfo({
    options: {
      refetchOnWindowFocus: false,
      enabled: true,
      gcTime: 0,
      refetchInterval,
      staleTime: Infinity,
    },
    onQuerySuccess: onQuerySuccess,
  })

  let outOfDate = false
  try {
    // We just need to check if the current version matches the latest version or not.
    // We can deploy old versions/roll back so we don't want to check which is older.
    outOfDate = !!latestVersionInfo && latestVersionInfo.version !== appVersion
  } catch (e) {
    console.error(e)
  }
  return {
    lastChecked,
    currentVersion: appVersion,
    latestVersion: latestVersionInfo?.version,
    isClientOutOfDate: outOfDate,
  }
}
